import * as tslib_1 from "tslib";
import { SwitchField } from './switch_field';
import { ToolHelper } from '../../../../../utility/index';
var CollectionSwitch = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionSwitch, _super);
    function CollectionSwitch(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        _this.contents = [];
        var keys = 'contents';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                obj[key].forEach(function (item) {
                    var domObj = ToolHelper.createObjectByType(item.type);
                    if (domObj) {
                        _this.contents.push(new domObj(item));
                    }
                });
            }
        });
        return _this;
    }
    CollectionSwitch.prototype.toJSON = function () {
        var result = [];
        if (this.contents && this.contents.length) {
            this.contents.forEach(function (item) {
                result.push(item.toJSON());
            });
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "CollectionSwitch",
            "contents": result
        });
    };
    CollectionSwitch.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return CollectionSwitch;
}(SwitchField));
export { CollectionSwitch };
//# sourceMappingURL=collection_switch.js.map